<template>
  <div id="internetUsageDashboard">
    <div v-if="school.site_code !== null">
      <Header
      pageIcon="language"
      :header="header"
      :content="content"
      :sitecode="school.site_code"
      />
      <v-container
      fluid
      style=""
      class="mb-0 pb-0 contentSpacer"
    >
      <v-card class="pa-5 mb-3 d-flex flex-row">
          <v-text-field
            single-line
            outlined
            hide-details
            clearable
            prepend-inner-icon="search"
            label="Enter website name"
            @input="handelInputSearchChange"
            v-model="searchText"
            class="pr-5 pl-1"
            id="search-bar"
          />
          <v-menu
            v-model="datePickerMenu"
            :close-on-content-click="false"
            :nudge-right="20"
            transition="scale-transition"
            offset-y
            max-width="290"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                single-line
                outlined
                hide-details
                :value="dateFormatted"
                label="Date range"
                prepend-inner-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dateSelected"
              @change="datePickerMenu = false"
              range
              :min="minDateRange"
              :max="maxDateRange"
              no-title
            ></v-date-picker>
          </v-menu>
          <v-btn
            text
            large
            @click="handelResetToDefault"
            style="height: 57px;"
            v-if="resetRequired"
          >
            <span style="text-transform: capitalize; font-weight: normal;font-size: 16px;">Reset</span>
          </v-btn>
      </v-card>
    </v-container>
      <v-container fluid class="mt-0 pt-0 contentSpacer">
      <v-row>
        <v-col cols="12" lg="12">
          <v-card>
            <v-card-title>
              <h3 class="headline mb-0" style="color: #1D428A; font-size: 18px !important; line-height: 27px;">
                Hourly Bandwidth Usage - Inbound and Outbound (Mbps)
              </h3>
            </v-card-title>
            <v-divider/>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  id="ictp-hc-hourly-bandwidth-usage"
                >
                  <HourlyBandwidthUsage
                    v-if="school.site_code !== null"
                    :sitecode="school.site_code"
                    :date-range="dateRange"
                    :search-input="inputSearch"
                  />
                  <v-alert
                    v-else
                    :value="true"
                    color="warning"
                    icon="priority_high"
                    outlined
                  >
                    Please select a school from the school picker in the top right to display data for this page. Simply
                    click
                    "Search for a school", then start typing the name of your desired school.
                  </v-alert>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
      <v-container fluid class="contentSpacer">
      <v-row>
        <v-col cols="12" lg="6">
          <v-card>
            <v-card-title>
              <h3 class="headline mb-0" style="color: #1D428A; font-size: 18px !important;; line-height: 27px;">
                Most visited websites (number of hits)
              </h3>
            </v-card-title>
            <v-divider/>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  lg="12"
                  id="ictp-hc-number-of-hits"
                >
                  <NumberOfHits
                    class="shadowbox"
                    v-if="school.site_code !== null"
                    :sitecode="school.site_code"
                    :date-range="dateRange"
                    :search-input="inputSearch"
                  />
                  <v-alert
                    v-else
                    :value="true"
                    color="warning"
                    icon="priority_high"
                    outlined
                  >
                    Please select a school from the school picker in the top right to display data for this page. Simply
                    click
                    "Search for a school", then start typing the name of your desired school.
                  </v-alert>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="text-lg-center">
                  <div>
                    <span class="span-dot-dark"></span> Department <span class="span-spacer"></span> <span
                    class="span-dot"></span> Non-Department
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
        <v-col cols="12" lg="6">
          <v-card>
            <v-card-title>
              <h3 class="headline mb-0" style="color: #1D428A; font-size: 18px !important;; line-height: 27px;">
                Websites using the most bandwidth (Mbps)
              </h3>
            </v-card-title>
            <v-divider/>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  lg="12"
                  id="ictp-hc-bandwidth-usage"
                >
                  <BandwidthUsage
                    class="shadowbox"
                    v-if="school.site_code !== null"
                    :sitecode="school.site_code"
                    :date-range="dateRange"
                    :search-input="inputSearch"
                  />
                  <v-alert
                    v-else
                    :value="true"
                    color="warning"
                    icon="priority_high"
                    outlined
                  >
                    Please select a school from the school picker in the top right to display data for this page. Simply
                    click
                    "Search for a school", then start typing the name of your desired school.
                  </v-alert>
                </v-col>
              </v-row>

              <v-row>
                <v-col class="text-lg-center">
                  <div>
                    <span class="span-dot-dark"></span> Department <span class="span-spacer"></span> <span
                    class="span-dot"></span> Non-Department
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    </div>
    <div class="contentSpacer" v-else>
      <EmptyState/>
    </div>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex';
  import HourlyBandwidthUsage from "../highcharts/HourlyBandwidthUsage";
  import NumberOfHits from "../highcharts/NumberOfHits";
  import BandwidthUsage from "../highcharts/BandwidthUsage";
  import Header from '../simpleComponents/Header';
  import EmptyState from "../simpleComponents/EmptyState";
  import {format, parse, subDays, compareAsc} from 'date-fns';
  import _ from 'lodash';
  const defaultDateRange = [subDays(new Date(), 30).toISOString().substr(0, 10), new Date().toISOString().substr(0, 10)];
  export default {
    name: "InternetUsageDashboard",
    components: {
      Header,
      HourlyBandwidthUsage,
      NumberOfHits,
      BandwidthUsage,
      EmptyState
    },
    data: () => ({
      datePickerMenu: false,
      dateSelected: defaultDateRange,
      minDateRange: subDays(new Date(), 180).toISOString().substr(0, 10),
      maxDateRange: new Date().toISOString().substr(0, 10),
      searchText: '',
      inputSearch: '',
      header: 'Internet Usage',
      content: 'This is your school’s internet traffic categorised by <strong>Department</strong> and <strong>Non-department</strong>. Each category is a combination of both upload and download data. Department data examples include most DOE applications such as SAP and Student Management. Non-department data refers general internet browsing such as YouTube and Google. \n' +
        '\n' +
        '<br/><br/>You can see a particular website’s usage by typing its name into the search bar below and choosing the date range you would like to see the data for. This will show you when it is being accessed, how often and how much bandwidth it uses.'
    }),
    computed: {
      ...mapGetters([
        'school',
      ]),
      dateFormatted() {
        let dateRangeSelected = this.buildRangeSelected();
        dateRangeSelected = dateRangeSelected.map(dateItem => {
          return format(dateItem, 'dd/MMM/yyyy');
        });
        return dateRangeSelected.join(' ~ ');
      },
      dateForReset() {
        let dateRangeSelected = this.buildDefaultRange();
        dateRangeSelected = dateRangeSelected.map(dateItem => {
          return format(dateItem, 'dd/MMM/yyyy');
        });
        return dateRangeSelected.join(' ~ ');
      },
      dateRange() {
        let dateRangeSelected = this.buildRangeSelected();
        let dateRangeFilter = {
          startDate: '',
          endDate: '',
        };
        if (Array.isArray(dateRangeSelected) && dateRangeSelected.length > 0) {
          if (dateRangeSelected.length > 1) {
            const startDate = dateRangeSelected[0].toISOString();
            const endDate = dateRangeSelected[1].toISOString();
            dateRangeFilter.startDate = startDate;
            dateRangeFilter.endDate = endDate;
          } else {
            const startDate = dateRangeSelected[0].toISOString();
            dateRangeFilter.startDate = startDate;
            dateRangeFilter.endDate = startDate;
          }
        }
        return dateRangeFilter;
      },
      resetRequired(){
        let resetDate = this.dateForReset;
        let selectedDate = this.dateFormatted;
        if(resetDate != selectedDate || this.inputSearch){
          return true;
        }
        return false;
      }
    },
    methods: {
      handelInputSearchChange: _.debounce(function (value) {
        this.inputSearch = value;
        console.log('this.inputSearch=' + this.inputSearch);
      }, 700),
      handelResetToDefault() {
        this.dateSelected = defaultDateRange;
        this.searchText = '';
        this.inputSearch = '';
      },
      buildRangeSelected() {
        let dateRangeSelected = _.cloneDeep(this.dateSelected);
        dateRangeSelected = dateRangeSelected.map(dateItem => {
          return parse(dateItem, 'yyyy-MM-dd', new Date());
        });
        dateRangeSelected.sort((a, b) => compareAsc(a, b));
        return dateRangeSelected;
      },
      buildDefaultRange() {
        let dateRangeSelected = _.cloneDeep(defaultDateRange);
        dateRangeSelected = dateRangeSelected.map(dateItem => {
          return parse(dateItem, 'yyyy-MM-dd', new Date());
        });
        dateRangeSelected.sort((a, b) => compareAsc(a, b));
        return dateRangeSelected;
      }
    },
  }
</script>
<style scoped>
  .span-dot {
    height: 8px;
    width: 8px;
    border-radius: 2px;
    background-color: #6BACE4;
    display: inline-block;
  }

  .span-dot-dark {
    height: 8px;
    width: 8px;
    border-radius: 2px;
    background-color: #1D428A;
    display: inline-block;
  }

  .span-spacer {
    width: 15px;
    display: inline-block;
  }

  .v-btn:hover {
    background-color: #C7DCF0 !important;
    /*opacity: 0.4 !important;*/
  }

  .theme--light.v-btn {
    color: #1D428A !important;
  }
</style>
